import React, { useEffect, useState } from 'react'
import './style.scss'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Paging = ({ pageNumber, selectPage, pages, changePageSize, totalCount, pageSize }) => {
    const [isEnterPageNumber, setIsEnterText] = useState()
    const [localPageNumber, setLocalPageNumber] = useState()
    const location = useLocation()
    const { t } = useTranslation()

    const typing = (e) => {

        const val = parseInt(e.target.value);
        if (val > 0 && val <= pages.length) {
            setLocalPageNumber(val)
        }




    }

    const isDsApp = () => {
        if (location.pathname.toLowerCase().indexOf("dsappcallreport") > -1) {
            return true
        }
        return false
    }

    useEffect(() => {
        window.clearTimeout(isEnterPageNumber);

        const _isTyping = setTimeout(function () {

            selectPage(localPageNumber)


        }, 2000);
        setIsEnterText(_isTyping)
    }, [localPageNumber])

    useEffect(() => {
        setLocalPageNumber(pageNumber)
    }, [pageNumber])


    return (<div className="custom-paging">
        {!isDsApp() ? <div className="info-txt">{`${pageNumber} - ${pageSize} از ${totalCount} اقلام`}</div> :
            <><div className="info-txt">{`تعداد کل ${totalCount}`}</div><br /></>
        }


        <div className="page-tools-context">
            <div>
                {pageNumber < pages.length ? <span className="page-spn" onClick={() => selectPage(pages.length)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z" /></svg>
                </span> : <span className="page-spn disabled">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z" /></svg>
                </span>}
                {pageNumber < pages.length ? <span className="page-spn" onClick={() => selectPage(pageNumber + 1)}>
                    <svg viewBox="0 0 24 24">
                        <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                    </svg>
                </span> : <span className="page-spn disabled">
                    <svg viewBox="0 0 24 24">
                        <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                    </svg>
                </span>}
                {!isDsApp() ? <label>{pages?.length}</label> : <label className='mx-3'>{localPageNumber}</label>}
                {!isDsApp() && <>/
                    <input type="number" value={localPageNumber} onChange={typing} /></>}
                {pageNumber > 1 ? <span className="page-spn" onClick={() => selectPage(pageNumber - 1)}>
                    <svg viewBox="0 0 24 24">
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                    </svg>
                </span> : <span className="page-spn disabled" >
                    <svg viewBox="0 0 24 24">
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                    </svg>
                </span>}
                {pageNumber > 1 ? <span className="page-spn" onClick={() => selectPage(1)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z" /></svg>
                </span> : <span className="page-spn disabled">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z" /></svg>
                </span>}
            </div>
            {!isDsApp() && <div className="page-size-tool">
                <select value={pageSize} onChange={(e) => {
                    selectPage(1);

                    changePageSize(parseInt(e.target.value));
                }}>
                    <option value="25" >25</option>
                    <option value="50" >50</option>
                    <option value="75" >75</option>
                    <option value="100" >100</option>

                </select>
                <label>{t('ITEM_IN_ANY_PAGE')}</label>

            </div>}
        </div>
    </div>)
}

export default Paging